<ul class="list-group">
  <li class="list-group-item p-3">
    <div class="position-relative">
      <a class="stretched-link" data-bs-toggle="collapse" href="#ExportFileRequests_Collapse" role="button" aria-expanded="false" aria-controls="ExportFileRequests_Collapse"> </a>
      <div class="d-flex align-items-center justify-content-between">
        <h5 class="m-0">Export File Requests</h5>
        <div class="d-flex align-items-center justify-content-end gap-4">
          @if (s3_requests.length > 0) {
            <span class="ms-3 badge text-bg-info px-3 py-2">{{s3_requests.length}} Requests</span>
          }
          <i class="fa-solid fa-chevron-down"></i>
        </div>
      </div>
    </div>
    <div class="collapse show" id="ExportFileRequests_Collapse">
      <hr>
        @if (s3_requests.length > 0) {
          <div class="card card-body bg-light-subtle-subtle p-3" style="max-height: 400px; overflow-y: auto; overflow-x: hidden;">
            <div class="row">
              @for (request of s3_requests; track request) {
                <div class="col-12 col-md-6 col-lg-4">
                  <div class="card mb-4">
                    <div class="card-body">
                      <div class="d-flex align-items-center justify-content-between w-100">
                        <p class="m-0"><i class="fa-solid fa-calendar-day me-2"></i>{{ timestamp_to_date(request.ReqReceivedTimestamp) | date: 'shortDate' }}</p>
                        <p class="m-0">
                          @switch (request.RequestReviewStatus) {
                            @case ('Approved') {
                              <span class="badge text-bg-success py-1">Approved</span>
                            }
                            @case ('Rejected') {
                              <span class="badge text-bg-danger py-1">Rejected</span>
                            }
                            @default {
                              <span class="badge text-bg-secondary py-1"> {{ request.RequestReviewStatus | titlecase }} </span>
                            }
                          }
                        </p>
                      </div>
                      <hr class="my-2">
                      <p class="m-0"><b>User:</b> {{ request.RequestedBy }}</p>
                      <p class="m-0"><b>Dataset:</b> {{request['Dataset-DataProvider-Datatype'] }}</p>
                      <p class="m-0"><b>File Name:</b> {{ request.S3Key }}</p>
                      <p class="m-0 text-truncate" data-bs-toggle="tooltip" data-bs-placement="top" [attr.data-bs-title]="'Justification: \n' + request.ApprovalForm.justification">
                        <b>Justification:</b>&nbsp;
                        <span [ngClass]="{'text-muted': !request.ApprovalForm.justification}">{{request.ApprovalForm.justification || " - - " }}</span>
                      </p>
                    </div>
                    <div class="card-footer p-2">
                      <div class="d-flex align-items-center justify-content-between gap-2">
                        <button class="btn btn-outline-info btn-sm flex-grow-1" (click)="toggle_view_request_details(request)"><i class="fa-solid fa-circle-info me-2"></i>More&nbsp;Details</button>
                        @if (request.RequestReviewStatus == 'Submitted') {
                          <div class="d-flex gap-2">
                            <button class="btn btn-success btn-sm" (click)="respond_file_request(true, request)"[disabled]="api_is_loading == true"><i class="fa-regular fa-thumbs-up"></i></button>
                            <button class="btn btn-danger btn-sm" (click)="respond_file_request(false, request)"[disabled]="api_is_loading == true"><i class="fa-regular fa-thumbs-down"></i></button>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        } @else {
          <div class="card">
            <div class="card-body bg-light-subtle-subtle">
              <div class="d-flex align-items-center justify-content-center p-4">
                <h5 class="text-center text-muted m-0">No Export File Requests</h5>
              </div>
            </div>
          </div>
        }


      </div>
    </li>
    <li class="list-group-item p-3">
      <div class="position-relative">
        <a class="stretched-link" data-bs-toggle="collapse" href="#ExportTableRequests_Collapse" role="button" aria-expanded="false" aria-controls="ExportTableRequests_Collapse"> </a>
        <div class="d-flex align-items-center justify-content-between">
          <h5 class="m-0">Export Table Requests</h5>
          <div class="d-flex align-items-center justify-content-end gap-4">
            @if (table_export_requests.length > 0) {
              <span class="ms-3 badge text-bg-info px-3 py-2">{{table_export_requests.length}} Requests</span>
            }
            <i class="fa-solid fa-chevron-down"></i>
          </div>
        </div>
      </div>
      <div class="collapse" id="ExportTableRequests_Collapse">
        <hr>
          @if (table_export_requests.length > 0) {
            <div class="card card-body bg-light-subtle-subtle p-3" style="max-height: 400px; overflow-y: auto; overflow-x: hidden;">
              <div class="row">
                @for (request of table_export_requests; track request) {
                  <div class="col-12 col-md-6 col-lg-4">
                    <div class="card mb-4">
                      <div class="card-body">
                        <div class="d-flex align-items-center justify-content-between w-100">
                          <p class="m-0"><i class="fa-solid fa-calendar-day me-2"></i>{{ timestamp_to_date(request.ReqReceivedTimestamp) | date: 'shortDate' }}</p>
                          <p class="m-0">
                            @switch (request.RequestReviewStatus) {
                              @case ('Approved') {
                                <span class="badge text-bg-success py-1">Approved</span>
                              }
                              @case ('Rejected') {
                                <span class="badge text-bg-danger py-1">Rejected</span>
                              }
                              @default {
                                <span class="badge text-bg-secondary py-1"> {{ request.RequestReviewStatus | titlecase }} </span>
                              }
                            }
                          </p>
                        </div>
                        <hr class="my-2">
                        <p class="m-0"><b>User:</b> {{ request.RequestedBy }}</p>
                        <p class="m-0"><b>Dataset:</b> {{request['Dataset-DataProvider-Datatype'] }}</p>
                        <p class="m-0"><b>Table Name:</b> {{ request.TableName }}</p>
                        <p class="m-0 text-truncate" data-bs-toggle="tooltip" data-bs-placement="top" [attr.data-bs-title]="'Justification: \n' + request.ApprovalForm.justifyExport">
                          <b>Justification:</b>&nbsp;
                          <span [ngClass]="{'text-muted': !request.ApprovalForm.justifyExport}">{{request.ApprovalForm.justifyExport || " - - " }}</span>
                        </p>
                      </div>
                      <div class="card-footer p-2">
                        <div class="d-flex align-items-center justify-content-between gap-2">
                          <button class="btn btn-outline-info btn-sm flex-grow-1" (click)="toggle_view_request_details(request)"><i class="fa-solid fa-circle-info me-2"></i>More&nbsp;Details</button>
                          @if (request.RequestReviewStatus == 'Submitted') {
                            <div class="d-flex gap-2">
                              <button class="btn btn-success btn-sm" (click)="respond_table_request(true, request)"[disabled]="api_is_loading == true"><i class="fa-regular fa-thumbs-up"></i></button>
                              <button class="btn btn-danger btn-sm" (click)="respond_table_request(false, request)"[disabled]="api_is_loading == true"><i class="fa-regular fa-thumbs-down"></i></button>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          } @else {
            <div class="card">
              <div class="card-body bg-light-subtle-subtle">
                <div class="d-flex align-items-center justify-content-center p-4">
                  <h5 class="text-center text-muted m-0">No Export Table Requests</h5>
                </div>
              </div>
            </div>
          }

        </div>
      </li>
      <li class="list-group-item p-3">
        <div class="position-relative">
          <a class="stretched-link" data-bs-toggle="collapse" href="#TrustedUserRequests_Collapse" role="button" aria-expanded="false" aria-controls="TrustedUserRequests_Collapse"> </a>
          <div class="d-flex align-items-center justify-content-between">
            <h5 class="m-0">Trusted User Requests</h5>
            <div class="d-flex align-items-center justify-content-end gap-4">
              @if (trusted_user_status_requests.length > 0) {
                <span class="ms-3 badge text-bg-info px-3 py-2">{{trusted_user_status_requests.length}} Requests</span>
              }
              <i class="fa-solid fa-chevron-down"></i>
            </div>
          </div>
        </div>
        <div class="collapse" id="TrustedUserRequests_Collapse">

          <hr>

            @if (trusted_user_status_requests.length > 0) {
              <div class="card card-body bg-light-subtle-subtle p-3" style="max-height: 400px; overflow-y: auto; overflow-x: hidden;">
                <div class="row">
                  @for (request of trusted_user_status_requests; track request) {
                    <div class="col-12 col-md-6 col-lg-4">
                      <div class="card mb-4">
                        <div class="card-body">
                          <div class="d-flex align-items-center justify-content-between w-100">
                            <p class="m-0"><i class="fa-solid fa-calendar-day me-2"></i>{{ timestamp_to_date(request.ReqReceivedTimestamp) | date: 'shortDate' }}</p>
                            <p class="m-0">
                              @switch (request.TrustedStatus) {
                                @case ('Trusted') {
                                  <span class="badge text-bg-success py-1">Trusted</span>
                                }
                                @case ('Untrusted') {
                                  <span class="badge text-bg-danger py-1">Untrusted</span>
                                }
                                @default {
                                  <span class="badge text-bg-secondary py-1"> {{ request.TrustedStatus | titlecase }} </span>
                                }
                              }
                            </p>
                          </div>
                          <hr class="my-2">
                          <p class="m-0"><b>User:</b> {{ request.UserID }}</p>
                          <p class="m-0"><b>Dataset:</b> {{request['Dataset-DataProvider-Datatype'] }}</p>
                          <p class="m-0 text-truncate" data-bs-toggle="tooltip" data-bs-placement="top" [attr.data-bs-title]="'Justification: \n' + request.TrustedJustification">
                            <b>Justification:</b>&nbsp;
                            <span [ngClass]="{'text-muted': !request.TrustedJustification}">{{request.TrustedJustification || " - - " }}</span>
                          </p>
                        </div>
                        <div class="card-footer p-2">
                          <div class="d-flex align-items-center justify-content-between gap-2">
                            <button class="btn btn-outline-info btn-sm flex-grow-1" (click)="toggle_view_request_details(request)"><i class="fa-solid fa-circle-info me-2"></i>More&nbsp;Details</button>
                            @if (request.TrustedStatus == 'Submitted') {
                              <div class="d-flex gap-2">
                                <button class="btn btn-success btn-sm" (click)="respond_trusted_request(true, request)"[disabled]="api_is_loading == true"><i class="fa-regular fa-thumbs-up"></i></button>
                                <button class="btn btn-danger btn-sm" (click)="respond_trusted_request(false, request)"[disabled]="api_is_loading == true"><i class="fa-regular fa-thumbs-down"></i></button>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            } @else {
              <div class="card">
                <div class="card-body bg-light-subtle-subtle">
                  <div class="d-flex align-items-center justify-content-center p-4">
                    <h5 class="text-center text-muted m-0">No Trusted User Requests</h5>
                  </div>
                </div>
              </div>
            }

          </div>
        </li>
      </ul>


      <app-modal #Modal_RequestDetails [size]="'md'">
        <ng-container modal-header>
          <div class="d-flex align-items-center justify-content-between w-100 p-2">
            <h5 class="m-0"> Request Details </h5>

            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" [(ngModel)]="view_raw_data">
              <label class="form-check-label" for="flexSwitchCheckDefault">View Raw JSON</label>
            </div>
          </div>
        </ng-container>
        <ng-container modal-body>
          @if (selected_request) {
            <div class="p-2">
              @if (view_raw_data == true) {
                <div class="card card-body bg-light-subtle-subtle">
                  <code><pre>{{ selected_request | json }}</pre></code>
                </div>
              } @else {
                <h5><small>Submission Details</small></h5>
                <div class="card card-body bg-light-subtle-subtle">
                  <div class="row">
                    <div class="col-6 mb-2">
                      <p class="mb-0"><small> <b>UserID</b> </small><br>{{selected_request.RequestedBy || selected_request.UserID}}</p>
                    </div>
                    <div class="col-6 mb-2">
                      <p class="mb-0"><small> <b>Email Address</b> </small><br>{{selected_request.UserEmail}}</p>
                    </div>
                    @if (selected_request.TeamBucket) {
                      <div class="col-6 mb-2">
                        <p class="mb-0"><small> <b>Team</b> </small><br>{{selected_request.TeamBucket}}</p>
                      </div>
                    }
                    @if (selected_request.S3Key && !selected_request.ApprovalForm.privateDatabase) {
                      <div class="col-6 mb-2">
                        <p class="mb-0"><small> <b>File Name</b> </small><br> {{selected_request.S3Key}}</p>
                      </div>
                    }
                    @if (selected_request.S3Key && selected_request.ApprovalForm.privateDatabase) {
                      <div class="col-6 mb-2">
                        <p class="mb-0"><small> <b>Table Name</b> </small><br> {{selected_request.S3Key}}</p>
                      </div>
                    }
                    <!--div class="col-6 mb-2" *ngIf="selected_request.TrustedStatus">
                    <p class="mb-0"><small> <b>Request Type</b> </small><br> {{ selected_request.TrustedStatus }} </p>
                  </div-->
                </div>
              </div>
              <hr>
                <h5><small>Request Details</small></h5>
                <div class="card card-body bg-light-subtle-subtle">
                  <div class="row">
                    @if (selected_request.ApprovalForm) {
                      @if (selected_request.ApprovalForm.request_type =='exportRequest') {
                        <div class="col-6 mb-2">
                          <p class="mb-2"><small><b>Requested DataSet</b></small><br>{{selected_request.ApprovalForm.project || " - - " }}<br>{{selected_request.ApprovalForm.provider || " - - " }}<br> {{selected_request.ApprovalForm.dataset || " - - " }}</p>
                        </div>
                        <div class="col-6 mb-2">
                          <p class="mb-0"><small><b>Additional Data Sources</b></small><br> {{selected_request.ApprovalForm.additional_data_sources || selected_request.ApprovalForm.datasources || " - - " }}</p>
                        </div>
                        <div class="col-6 mb-2">
                          <p class="mb-0"><small><b>Requestor Provided Name</b></small><br>{{selected_request.ApprovalForm.name  || ' - - '}}</p>
                        </div>
                        <div class="col-4 mb-2">
                          <p class="mb-0"><small><b>Requestor Provided Address</b></small><br>{{selected_request.ApprovalForm.address || ' - - '}}<br>{{selected_request.ApprovalForm.city || ' - - '}}, {{selected_request.ApprovalForm.state || ' - - '}}  {{selected_request.ApprovalForm.zipcode || ' - - '}}</p>
                        </div>
                        <div class="col-4 mb-2">
                          <p class="mb-0"><small><b>Requestor Provided Email</b></small><br>{{selected_request.ApprovalForm.email}}</p>
                        </div>
                        <div class="col-12">
                          <hr>
                            <p class="m-0"><small><b>Justification</b></small><br>{{selected_request.ApprovalForm.justifyExport || selected_request.ApprovalForm.justification || " - - " }}</p>
                          </div>
                        }
                        @if (selected_request.TableName) {
                          <!--div class="col-6 mb-2">
                          <p class="mb-0"><small><b>Requestor Name</b></small><br> {{selected_request.ApprovalForm.name  ||  selected_request.ApprovalForm.derivedDataSetname}}</p>
                        </div-->
                        <div class="col-6 mb-2">
                          <p class="mb-0"><small><b>Project/Dataset</b></small><br>{{selected_request.ApprovalForm.datasetName || " - - " }}</p>
                        </div>
                        <div class="col-6 mb-2">
                          <p class="mb-0"><small><b>Data Provider</b></small><br> {{selected_request.ApprovalForm.dataprovider || " - - " }}</p>
                        </div>
                        <div class="col-6 mb-2">
                          <p class="mb-0"><small><b>Sub-dataset or Data Type</b></small><br> {{selected_request.ApprovalForm.datatype || " - - " }}</p>
                        </div>
                        <div class="col-6 mb-2">
                          <p class="mb-0"><small><b>Additional Data Sources</b></small><br> {{selected_request.ApprovalForm.datasources || " - - " }}</p>
                        </div>
                        <div class="col-12">
                          <hr>
                            <p class="m-0"><small><b>Justification</b></small><br>{{selected_request.ApprovalForm.justifyExport || " - - " }}</p>
                          </div>
                        }
                      }
                      @if (selected_request.TrustedStatus) {
                        <div class="col-12">
                          <p class="m-0"><small><b>Justification</b></small><br>{{ selected_request.TrustedJustification || " - - " }}</p>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </ng-container>
          <ng-container modal-footer>
            <div class="d-flex align-items-center justify-content-between w-100">
              <button class="btn btn-secondary" (click)="close_request_details_modal()">Close</button>
            </div>
          </ng-container>
        </app-modal>